import { Loader2 } from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * <LoadMore /> — renders the "Load more" button + a small counter showing
 * how many items are visible out of the total.
 *
 * Use with `useLoadMore()` hook from src/hooks/useLoadMore.
 */
export function LoadMore({ hasMore, onLoadMore, visibleCount, total, pageSize = 10, loading = false }) {
  const remaining = total - visibleCount;
  if (!hasMore && total > 0) {
    return (
      <div className="text-2xs text-fg-subtle text-center pt-3">
        Showing all {total} {total === 1 ? 'item' : 'items'}
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center gap-1 pt-3">
      <button
        type="button"
        onClick={onLoadMore}
        disabled={!hasMore || loading}
        className={cn(
          'inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md',
          'border border-border bg-surface-2 text-fg-muted hover:text-fg',
          'hover:border-border-strong hover:bg-surface-3 transition-colors',
          'disabled:opacity-50 disabled:cursor-not-allowed'
        )}
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        Load {Math.min(pageSize, remaining)} more
      </button>
      <div className="text-2xs text-fg-subtle">
        Showing {visibleCount} of {total}
      </div>
    </div>
  );
}
